import { useEffect, useState } from 'react'
import { supabase } from '@/lib/supabase'

export type MyApps = {
  viewer: boolean
  guild: boolean
  studio: boolean
}

const EMPTY_APPS: MyApps = { viewer: false, guild: false, studio: false }

function parseMyApps(data: unknown): MyApps {
  if (!data || typeof data !== 'object') return EMPTY_APPS
  const record = data as Record<string, unknown>
  return {
    viewer: Boolean(record.viewer),
    guild: Boolean(record.guild),
    studio: Boolean(record.studio),
  }
}

export async function fetchMyApps(): Promise<MyApps> {
  const { data, error } = await supabase.rpc('my_apps')
  if (error) return EMPTY_APPS
  return parseMyApps(data)
}

export function useMyApps(userId: string | undefined): MyApps | null {
  const [apps, setApps] = useState<MyApps | null>(null)

  useEffect(() => {
    if (!userId) {
      setApps(null)
      return
    }
    void fetchMyApps().then(setApps)
  }, [userId])

  return apps
}
